import { lazy } from "react";
import { Workflows, Root } from "@/routes";
import { createBrowserRouter } from "react-router";

const Workflow = lazy(() =>
  import("@/routes").then((m) => ({ default: m.Workflow })),
);
const NewWorkflowSelectionPage = lazy(() =>
  import("@/routes").then((m) => ({ default: m.NewWorkflowSelectionPage })),
);
const NewWorkflowFromDefinitionPage = lazy(() =>
  import("@/routes").then((m) => ({
    default: m.NewWorkflowFromDefinitionPage,
  })),
);
const MarkdownTester = lazy(() =>
  import("@/routes").then((m) => ({ default: m.MarkdownTester })),
);
const WorkflowInstance = lazy(() =>
  import("@/routes").then((m) => ({ default: m.WorkflowInstance })),
);

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Root,
    children: [{ index: true, Component: Workflows }],
  },
  {
    path: "/workflow/:workflowId",
    Component: Workflow,
  },
  {
    path: "/workflow-instance/:workflowInstanceId",
    Component: WorkflowInstance,
  },
  {
    path: "/workflow/create",
    Component: NewWorkflowSelectionPage,
  },
  {
    path: "/workflow/create/:workflowDefinitionId",
    Component: NewWorkflowFromDefinitionPage,
  },
  // We'll want to remove this route before release, but thought it might be handy for the use case team
  {
    path: "/markdown-tester",
    Component: MarkdownTester,
  },
]);
